import axios from 'axios';
import cfac22 from 'js/library/utils/cfac22';

export async function editUserPartner(uid, clubId, partnerList) {
  const result = await axios.put(
    `${cfac22('API_HOST_V2')}/userPartner/editUserPartner`,
    { uid, clubId, partnerList },
    { headers: { 'Full-Url': window.location.href }, withCredentials: true }
  );
  return result.data.response;
}

